import { useMutation } from '@tanstack/vue-query';
import { useToast } from '@/_core/shared/ui/AppToast/useToast';
import { downloadSingleScanPdf, downloadAppVersionPdf } from './report.endpoints';
import type { TDownloadPdfPayload } from '../models/types';

function downloadFile(url: string) {
  const link = document.createElement('a');
  link.href = url;
  link.click();
}

export function useDownloadPdfReport() {
  const toast = useToast();

  return useMutation({
    mutationFn: (params: TDownloadPdfPayload) => {
      if (params.isSingleScan) {
        return downloadSingleScanPdf(params);
      }
      return downloadAppVersionPdf(params);
    },
    onSuccess: (data) => {
      downloadFile(data.url);
    },
    onError: () => {
      toast.error({ message: 'Failed to download PDF report' });
    },
  });
}
